<template>
  <div>
    <Banner :isBannerOpen="isBannerOpen">
      <template slot="header">
        Subscription Alert!!
      </template>
      <template>
        {{ emptyBannerMessage }} For further queries contact <a class="first-link" href="https://support@enerman.in">support@enerman.in</a><u class="second-link"> Renew</u>
      </template>
    </Banner>
    <PlantOverviewSkeleton v-if="$route.path == '/newplantOverview' || $route.path == '/plantOverview'" />
    <CardSkeleton v-else-if="$route.path == '/general/more' || $route.path == '/general/devices'" />
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'


import Banner from '../Banner'
import PlantOverviewSkeleton from '../Plant Overview New/PlantOverviewSkeleton'
import CardSkeleton from '../CardSkeleton'

export default {
  components: {
    Banner,
    PlantOverviewSkeleton,
    CardSkeleton
  },
  data() {
    return {
      isBannerOpen: true
    }
  },
  computed: {
    ...mapGetters([
      "isRenewExceeded",
      "isPlantExpired",
      'getSelectedPlantId',
      "getUserInfo"
    ]),
    emptyBannerMessage() {
      if (this.isPlantExpired(this.getSelectedPlantId)) {
        return this.getUserInfo('banner_messages') && this.getUserInfo('banner_messages').others && this.getUserInfo('banner_messages').others.has_expired ? this.getUserInfo('banner_messages').others.has_expired : "Your Subscription for this plant has expired."
      } else if (this.isRenewExceeded(this.getSelectedPlantId)) {
        return this.getUserInfo('banner_messages') && this.getUserInfo('banner_messages').others && this.getUserInfo('banner_messages').others.is_to_renew ? this.getUserInfo('banner_messages').others.is_to_renew : "Your Subscription for this plant has crossed renew date."
      }
    }
  }
}
</script>

<style scoped>
  .first-link{
    color: #534b00 !important;
    text-decoration-line: underline;
  }
  .second-link{
    color: #485bff;
    cursor: pointer;
  }
</style>